{
  "Add a new card": "Add a new card",
  "Add a new ACH account": "Add a new ACH account",
  "Bank": "Bank",
  "Visa": "Visa",
  "Mastercard": "Mastercard",
  "Discover": "Discover",
  "Amerian Express": "American Express",
  "Auto-Pay On": "Auto-Pay On",
  "Auto-Pay Off": "Auto-Pay Off",
  "Payment Method Missing": "Payment Method Missing",
  "Home": "Home",
  "Reserve": "Reserve",
  "Menu & Events": "Menu & Events",
  "Billing": "Billing",
  "Sign Out": "Sign Out",
  "Issued Date": "Issued Date",
  "Invoice Number": "Invoice Number",
  "Description": "Description",
  "Invoice Payment Amount": "Invoice Payment Amount",
  "Due Date": "Due Date",
  "Status": "Status",
  "invoiceEmptyState": "You currently don’t have any unpaid invoices here.",
  "Payment Due": "Payment Due",
  "Late": "Late",
  "Paid": "Paid",
  "Processing": "Processing",
  "Failed": "Failed",
  "Voided": "Voided",
  "Member Benefits": "Member Benefits",
  "Meeting Room": "Meeting Room",
  "Office": "Office",
  "Desk": "Desk",
  "Open Workspace": "Open Workspace",
  "New": "New",
  "Your Profile": "Your Profile",
  "Company Profile": "Company Profile",
  "Member Management": "Member Management",
  "FAQ": "FAQ",
  "Notification Settings": "Notification Settings",
  "Refer a Friend": "Refer a Friend",
  "beta": "beta",
  "Something Went Wrong": "Something Went Wrong",
  "Page Not Found": "Page Not Found",
  "Please refresh the page and try again.": "Please refresh the page and try again.",
  "Please try our home page.": "Please try our home page.",
  "Refresh": "Refresh",
  "Please pay your first invoice to activate your membership.": "Please pay your first invoice to activate your membership.",
  "View Proposal": "View Proposal",
  "View Agreement": "View Agreement"
}
